import { ReactElement, ReactNode } from "react"
import { AttachmentIcon } from "../../icons/AttachmentIcon"
import { BriefcaseIcon } from "../../icons/briefcaseIcon"
import { ControlManagementIcon } from "../../icons/ControlManagementIcon"
import { DangerIcon } from "../../icons/DangerIcon"
import { ProtocolIcon } from "../../icons/entryProtocolIcon"
import { FolderIcon } from "../../icons/FolderIcon"
import { GestPersonaleIcon } from "../../icons/gestPersonaleIcon"
import { HomeIcon } from "../../icons/home"
import { ToolsIcon } from "../../icons/ToolsIcon"
import { UsersIcon } from "../../icons/users"

interface MenuItemDetails {
    label: string;
    subMenu?: boolean;
    subMenuItem?: SubMenuItem[]
}

interface SubMenuItem {
    label: string;
    link: string;
    icon?: ReactNode
}

export enum MenuItems {
    DASHBOARD = 'DASHBOARD',
    USERS = 'USERS',
    CLIENTI = 'CLIENTI',
    TECNICO_AZIENDALE = 'TECNICO_AZIENDALE',
    GESTIONE_PERSONALE = 'GESTIONE_PERSONALE',
    PROTOCOLLO = 'PROTOCOLLO',
    GESTIONE_ALLEGATI = 'GESTIONE_ALLEGATI',
    CARTELLA_AZIENDALE = 'CARTELLA_AZIENDALE',
    GESTIONE_CLIENTI = 'GESTIONE_CLIENTI',
    GESTIONE_CONTROLLO = 'GESTIONE_CONTROLLO',
    GESTIONE_CONTROLLO_ISPETTORE = 'GESTIONE_CONTROLLO_ISPETTORE',
    GESTIONE_CERTIFICAZIONE = 'GESTIONE_CERTIFICAZIONE',
    GESTIONE_PROVVEDIMENTI = 'GESTIONE_PROVVEDIMENTI',
    AMMINISTRAZIONE = 'AMMINISTRAZIONE',
    STRUMENTI = 'STRUMENTI'
}

export const MenuItemsLabelMap = new Map<MenuItems, MenuItemDetails>([
    [MenuItems.DASHBOARD, { label: 'Dashboard' }],
    [MenuItems.USERS, { label: 'Utenti' }],
    [MenuItems.CLIENTI, { label: 'Clienti' }],
    [MenuItems.TECNICO_AZIENDALE, { label: 'Tecnico Aziendale' }],
    [
        MenuItems.GESTIONE_PERSONALE,
        {
            label: 'Gestione Personale',
            subMenu: true,
            subMenuItem: [
                { label: 'Elenco Personale', link: '/gestionePersonale', },
                { label: 'Formazione', link: '/formazione' }
            ]
        }
    ],
    [
        MenuItems.PROTOCOLLO,
        {
            label: 'Protocollo',
            subMenu: true,
            subMenuItem: [
                { label: 'Entrata', link: '/entryProtocol', },
                { label: 'Partenza', link: '/departureProtocol' },
                { label: 'Report', link: '/reportProtocol' },
                { label: 'Protocollo Pre 2015', link: '/protocolloPre2015' }
            ]
        }
    ],
    [
        MenuItems.GESTIONE_ALLEGATI,
        {
            label: 'Gestione Allegati',
            subMenu: true,
            subMenuItem: [
                { label: 'Entrata', link: '/gaEntrata', },
                { label: 'Partenza', link: '/gaPartenza' }
            ]
        }
    ],
    [MenuItems.CARTELLA_AZIENDALE, { label: 'Cartella Aziendale' }],
    [
        MenuItems.GESTIONE_CLIENTI,
        {
            label: 'Gestione Clienti',
            subMenu: true,
            subMenuItem: [
                { label: 'R.I.D.', link: '/rid', },
                { label: 'Monitoraggio R.I.D.', link: '/monitoraggioRid', },
                { label: 'Documenti', link: '/gestioneDocumenti' },
                { label: 'Registri Aziendali', link: '/registriAziendali' },
                { label: 'Report Registri Aziendali', link: '/reportRegistroAziendale' },
                { label: 'Gestione Demeter', link: '/gestioneDemeter' },
                { label: 'Gestione Biosuisse', link: '/gestioneBiosuisse' }
            ]
        }
    ],
    [
        MenuItems.GESTIONE_CONTROLLO,
        {
            label: 'Gestione Controllo',
            subMenu: true,
            subMenuItem: [
                { label: 'Segnalazioni', link: '/segnalazioni' },
                { label: 'Liberatorie', link: '/liberatorie' },
                { label: 'PAC', link: '/pac' },
                { label: 'Gestione Prelievi', link: '/gestionePrelieviForAll' },
                { label: 'Periodo Conversione', link: '/periodoConversione' },
                { label: 'Notifiche', link: '/notify' },
                { label: 'Incarichi', link: '/incarichi' },
                { label: 'Monitoraggio Fase Avvio', link: '/monitoringFaseAvvio' },
                // { label: 'Monitoraggio BioSuisse', link: '/monitoringBioSuisse' },
                { label: 'Elenco M024', link: '/listM024' },
                { label: 'Monitoraggio Valutazioni', link: '/monitoraggioValutazioni' },
                { label: 'Monitoraggio M24 Aperti', link: '/monitoraggioM24Aperti' },
                { label: 'Monitoraggio M24 Emessi', link: '/monitoraggioM24Emessi' },
                { label: 'Monitoraggio Notifiche 2023', link: '/monitoraggioNotifiche2023' },
                { label: 'Report Provvedimenti', link: '/reportProvvedimenti' },
                // { label: 'Elenco M018', link: '/customerM018' },
            ]
        }
    ],
    [
        MenuItems.GESTIONE_CONTROLLO_ISPETTORE,
        {
            label: 'Gestione Controllo',
            subMenu: true,
            subMenuItem: [
                { label: 'Gestione Prelievi', link: '/gestionePrelieviForAll' },
                { label: 'Incarichi', link: '/incarichi' },
            ]
        }
    ],
    [
        MenuItems.GESTIONE_CERTIFICAZIONE,
        {
            label: 'Certificazione',
            subMenu: true,
            subMenuItem: [
                { label: 'Richieste di Conformità', link: '/complianceRequests' },
            ]
        }
    ],
    [
        MenuItems.GESTIONE_PROVVEDIMENTI,
        {
            label: 'Provvedimenti',
            subMenu: true,
            subMenuItem: [
                { label: 'Controllo Rinforzato', link: '/reinforcedControlMeasure' },
                { label: 'Provvedimenti Cliente', link: '/provvedimentiCliente' },
                { label: 'Elenco Provvedimenti', link: '/elencoCompletoProvvedimenti' },
            ]
        }
    ],
    [
        MenuItems.AMMINISTRAZIONE,
        {
            label: 'Amministrazione',
            subMenu: true,
            subMenuItem: [
                { label: 'Scheda di Calcolo', link: '/schedaCalcoloCustomer' },
                { label: 'Personale Contabile', link: '/personaleContabile' },
                { label: 'Report Personale Contabile', link: '/reportPersonaleContabile' },
            ]
        }
    ],
    [
        MenuItems.STRUMENTI,
        {
            label: 'Strumenti',
            subMenu: true,
            subMenuItem: [
                { label: 'Gestione', link: '/gestione', },
            ]
        }
    ]
])

export const MenuItemsHrefMap = new Map<MenuItems, string>([
    [MenuItems.DASHBOARD, '/'],
    [MenuItems.USERS, '/users'],
    [MenuItems.CLIENTI, '/customers'],
    [MenuItems.TECNICO_AZIENDALE, '/tecnico-aziendale'],
    [MenuItems.GESTIONE_PERSONALE, '/gestionePersonale'],
    [MenuItems.PROTOCOLLO, '/protocol'],
    [MenuItems.GESTIONE_ALLEGATI, '/gestioneAllegati'],
    [MenuItems.CARTELLA_AZIENDALE, '/cartellaAziendale'],
    [MenuItems.GESTIONE_CLIENTI, '/rid'],
    [MenuItems.GESTIONE_CONTROLLO, '/segnalazioni'],
    [MenuItems.GESTIONE_CERTIFICAZIONE, '/complianceRequests'],
    [MenuItems.GESTIONE_PROVVEDIMENTI, '/reinforcedControlMeasure'],
    [MenuItems.AMMINISTRAZIONE, '/schedaCalcoloCustomer'],
    [MenuItems.STRUMENTI, '/gestione'],
])

export const MenuItemsActivePathsMap = new Map<MenuItems, string[]>([
    [MenuItems.DASHBOARD, ['/']],
    [MenuItems.USERS, ['users', 'user', 'edit-user']],
    [MenuItems.CLIENTI, ['customers', 'customer', 'edit-customer', 'new-customer']],
    [MenuItems.TECNICO_AZIENDALE, ['tecnico-aziendale', 'tecnicoAziendale', 'editTecnicoAziendale']],
    [MenuItems.GESTIONE_PERSONALE, ['gestionePersonale', 'formazione', 'nuovoFormazione', 'editFormazione', 'nuovoPersonale', 'editPm']],
    [MenuItems.PROTOCOLLO, ['protocol', 'entryProtocol', 'departureProtocol', 'reportProtocol', 'addEntryProtocol', 'editEntryProtocol', 'addDepartureProtocol', 'editDepartureProtocol', 'protocolloPre2015']],
    [MenuItems.GESTIONE_ALLEGATI, ['gestioneAllegati', 'gaEntrata', 'gaPartenza']],
    [MenuItems.CARTELLA_AZIENDALE, ['cartellaAziendale']],
    [MenuItems.GESTIONE_CLIENTI, ['rid', 'addRid', 'editRid', 'monitoraggioRid', 'gestioneDocumenti', 'registriAziendali', 'reportRegistroAziendale', 'gestioneDemeter', 'gestioneBiosuisse', 'addRegistroAziendale', 'editRegistroAziendale']],
    [MenuItems.GESTIONE_CONTROLLO, ['segnalazioni', 'liberatorie', 'pac', 'gestionePrelieviForAll', 'periodoConversione', 'notify', 'incarichi', 'monitoringFaseAvvio', 'listM024', 'monitoraggioValutazioni', 'monitoraggioM24Aperti', 'monitoraggioM24Emessi', 'monitoraggioNotifiche2023', 'reportProvvedimenti', 'addSegnalazione', 'editSegnalazione', 'addPac', 'editPac']],
    [MenuItems.GESTIONE_CERTIFICAZIONE, ['complianceRequests']],
    [MenuItems.GESTIONE_PROVVEDIMENTI, ['reinforcedControlMeasure', 'provvedimentiCliente', 'elencoCompletoProvvedimenti']],
    [MenuItems.AMMINISTRAZIONE, ['schedaCalcoloCustomer', 'personaleContabile', 'reportPersonaleContabile']],
    [MenuItems.STRUMENTI, ['gestione']],
])

export const PathMenuItemMap = new Map<string, MenuItems>([
    ['dashboard', MenuItems.DASHBOARD],
    ['utenti', MenuItems.USERS],
    ['clienti', MenuItems.CLIENTI],
    ['tecnico_aziendale', MenuItems.TECNICO_AZIENDALE],
])

export function MenuItemsIconsMap(menuItem: MenuItems, color: string, size: number): ReactElement {
    const map = new Map<MenuItems, ReactElement>([
        [MenuItems.DASHBOARD, <HomeIcon color={color} size={size} />],
        [MenuItems.USERS, <UsersIcon color={color} size={size} />],
        [MenuItems.CLIENTI, <UsersIcon color={color} size={size} />],
        [MenuItems.TECNICO_AZIENDALE, <UsersIcon color={color} size={size} />],
        [MenuItems.GESTIONE_PERSONALE, <GestPersonaleIcon color={color} size={size} />],
        [MenuItems.PROTOCOLLO, <ProtocolIcon color={color} size={size} />],
        [MenuItems.GESTIONE_ALLEGATI, <AttachmentIcon color={color} size={size} />],
        [MenuItems.CARTELLA_AZIENDALE, <FolderIcon color={color} size={size} />],
        [MenuItems.GESTIONE_CLIENTI, <GestPersonaleIcon color={color} size={size} />],
        [MenuItems.GESTIONE_CONTROLLO, <ControlManagementIcon color={color} size={size} />],
        [MenuItems.GESTIONE_CERTIFICAZIONE, <ControlManagementIcon color={color} size={size} />],
        [MenuItems.GESTIONE_PROVVEDIMENTI, <DangerIcon color={color} size={size} />],
        [MenuItems.AMMINISTRAZIONE, <BriefcaseIcon color={color} size={size} />],
        [MenuItems.STRUMENTI, <ToolsIcon color={color} size={size} />]
    ])

    return (map.get(menuItem)!)
}